import { AccountAuthorizationList } from 'core/cuenta/components/AccountAuthorizationList/AccountAuthorizationList';
import { AccountDetailsAuthorizations } from 'core/cuenta/components/AccountDetailsAuthorizations/AccountDetailsAuthorizations';
import { AccountAuthorizationsContext } from 'core/cuenta/contexts/AccountAuthorizationsContext';
import { useContext } from 'react';
import { Alert, Col, Container, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { LinkButton } from 'shared/components';

export const AccountAuthorizationPage = () => {
  const { authorizations } = useContext(AccountAuthorizationsContext);
  window.history.replaceState({}, document.title);
  const navigate = useNavigate();
  const { state } = useLocation();

  const goBack = () => {
    let route = '/';
    let transferState = { state: {} as any };
    if (state.accountTotals && state.previous) {
      route = state.previous;
      transferState.state.accountTotals = state.accountTotals;
    }
    navigate(route, transferState);
  };

  return (
    <Container>
      {authorizations ? (
        <>
          <Row className="mb-3">
            <Col>
              <AccountDetailsAuthorizations />
            </Col>
          </Row>
          <Row>
            <Col>
              <Alert variant="info" className="text-center">
                Estos movimientos corresponden a consumos autorizados, pendientes de
                presentación por parte del establecimiento. Los mismos se consideran para
                calcular el disponible de la cuenta.
              </Alert>
            </Col>
          </Row>
          <Row>
            <Col>
              <AccountAuthorizationList />
            </Col>
          </Row>
        </>
      ) : (
        <Row>
          <Col>
            <Alert variant="info" className="text-center">
              No existen datos disponibles para su consulta.
            </Alert>
          </Col>
        </Row>
      )}
      <Row>
        <Col className="text-center">
          <LinkButton onClick={goBack}>Volver</LinkButton>
        </Col>
      </Row>
    </Container>
  );
};
